var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",staticStyle:{"background-color":"white"},attrs:{"id":"footer"}},[_c('img',{staticStyle:{"margin-right":"16px","margin-left":"16px"},attrs:{"height":"32px","width":"32px","src":"/assets/img/logo_base.png","alt":""}}),_vm._v(" "+_vm._s(_vm.copyrightLine)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }